import React, { ChangeEvent, Ref, FocusEvent } from "react";

import { Required, FieldWrapper, FieldWrapperProps } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { colors } from "shared/styles/constants";
import { CheckBoxWrapper } from "./styles";

export interface CheckboxProps extends FieldWrapperProps {
  index?: number;
  label?: string | JSX.Element;
  icon?: React.ComponentType<any>;
  value: string;
  registerRef?: Ref<HTMLInputElement>;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  superLabel?: string | JSX.Element;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  value,
  index,
  label,
  icon,
  registerRef,
  required,
  checked,
  onChange,
  onBlur,
  error,
  defaultChecked,
  disabled,
  superLabel,
  ...rest
}) => (
  <FieldWrapper name={name} error={error} label={superLabel} {...rest}>
    <CheckBoxWrapper error={!!error}>
      <label>
        <input
          type="checkbox"
          name={name}
          id={`${name}_${value}`}
          value={value}
          ref={registerRef}
          onChange={onChange}
          defaultChecked={defaultChecked}
          checked={checked}
          onBlur={onBlur}
          disabled={disabled}
        />
        <Spacer size="xxs" spaceDirection="horizontal" align="center">
          {icon && <Icon as={icon} size="l" color={colors.grey4} />}
          <span>
            {label}
            {required && <Required />}
          </span>
        </Spacer>
      </label>
    </CheckBoxWrapper>
  </FieldWrapper>
);
